import React from "react";
import { fmtNum } from "../../utils/formatters";
import { T } from "../../constants/theme";

/** Stock row */
const StockRow = ({ item, loading }) => {
  const statusColor = { OK: T.green, Low: T.yellow, Critical: T.red }[item.status] || T.muted;
  const pct = Math.min(100, Math.round((item.inStock / (item.reorderLevel * 3)) * 100));

  return (
    <div style={{ marginBottom: "10px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "4px",
        }}
      >
        <span style={{ fontSize: "12px", fontWeight: 500, color: T.text }}>{item.item}</span>
        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <span
            style={{
              fontSize: "10px",
              padding: "1px 6px",
              borderRadius: "10px",
              background: `${statusColor}20`,
              color: statusColor,
              fontWeight: 700,
            }}
          >
            {item.status}
          </span>
          <span style={{ fontSize: "12px", fontWeight: 700, color: T.text }}>
            {loading ? "…" : `${fmtNum(item.inStock)} ${item.unit}`}
          </span>
        </div>
      </div>
      <div
        title={`${pct}% of safe stock level`}
        style={{
          display: "block",
          width: "100%",
          height: "5px",
          background: "#f1f3f5",
          borderRadius: "4px",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            width: `${pct}%`,
            height: "100%",
            background: statusColor,
            borderRadius: "4px",
            transition: "width 0.7s cubic-bezier(0.22,1,0.36,1)",
          }}
        />
      </div>
      <div style={{ fontSize: "10px", color: T.muted, marginTop: "3px" }}>
        Reorder at {fmtNum(item.reorderLevel)} {item.unit}
      </div>
    </div>
  );
};

export default StockRow;
